var currentCameraIndex = -1;
$(document).on('turbo:load', () => {

  $(document).on("direct-uploads:start", (event) => {
    $('.upload-form-container').hide();
    $('.upload-in-progress-overlay').show();
  });

  $("#video-btn").on("click", () => {
    if ('mediaDevices' in navigator && 'getUserMedia' in navigator.mediaDevices) {
      startCameraStream();
    }
  });

  $("#retake-photo-container").on("click", () => {
    // ensure we don't continue to iterate through our cameras when they just click retake
    currentCameraIndex -= 1;

    if ('mediaDevices' in navigator && 'getUserMedia' in navigator.mediaDevices) {
      startCameraStream();
    }
  });

  $('#screenshot-btn').on("click", (event) => {
    var canvas = document.getElementById('canvas');
    var video = document.getElementById('video');
    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;
    canvas.getContext('2d').drawImage(video, 0, 0);
    var data = canvas.toDataURL('image/png');
    $('#screenshot-img').attr("src", data);
    $('#screenshot-img').show();
    $('#video').hide();
    $('#picture-data-field').val(data);
    $('#camera-controls-container').hide();

    $('#camera-submit-btn').css("z-index", "99999999999");
    $('#camera-submit-btn').show();

    var stream = video.srcObject;
    stream.getTracks().forEach(track => track.stop());
  });

  $('#camera-list-container').on("click", (event) => {
    startCameraStream();
  });

  $('#take-pic-form').on("submit", (event) => { 
    $('.upload-form-container').hide();
    $('.upload-in-progress-overlay').show();
  });
});

var startCameraStream = async () => {
  var devices = await navigator.mediaDevices.enumerateDevices();
  var cameraList = devices.filter((device) => {
    return device.kind.toLowerCase() === "videoinput";
  });

  // if the camera list is only one, it's usually the front-facing camera on ios. we try to start it, and 
  // then the other camera will be allowed to be shown to us.
  if (cameraList.length === 1) {
    await navigator.mediaDevices.getUserMedia( { video: true });
    devices = await navigator.mediaDevices.enumerateDevices();
    cameraList = devices.filter((device) => {
      return device.kind.toLowerCase() === "videoinput";
    });
  }

  // always sort the list by front facing camera first
  cameraList = cameraList.reverse();
  cameraList = cameraList.sort((a, b) => {
    if (a["label"].toLowerCase().includes("rear") || a["label"].toLowerCase().includes("back") || a["label"].toLowerCase().includes("environment")) {
      return -1;
    }  else if (b["label"].toLowerCase().includes("rear") || b["label"].toLowerCase().includes("back") || b["label"].toLowerCase().includes("environment")) {
      return 1;
    } else {
      return 0;
    }
  });

  var constraints;
  currentCameraIndex += 1;

  if (currentCameraIndex >= cameraList.length) {
    currentCameraIndex = 0;
  }

  var device = cameraList[currentCameraIndex].deviceId;

  constraints = { video: { deviceId: { exact: device } } };
  
  navigator.mediaDevices.getUserMedia(constraints)
  .then((stream) => {
    $('#video-container').css("display", "flex");
    $('#screenshot-img').hide();
    $('#camera-submit-btn').hide();
    $('#camera-controls-container').show();
    var video = document.getElementById('video');
    video.srcObject = stream;
    $('#video').show();
  }).catch((err) => {

  });

}